import type { CSSProperties, ReactNode } from 'react';
import { Menu } from 'lucide-react';
import { useAppDispatch } from '@store/hooks';
import { SET_NAV_OPEN } from '@store/app/app.reducer';
import IconButton from './IconButton';

/**
 * The legacy page header bars (@zawarski/palmetto-ui-components
 * HeaderComponent / DualTitleHeaderComponent): a 56px #2961FD band with a
 * 48px icon slot on the left, the title(s) in the middle and a suffix slot
 * (usually the more-menu) on the right.
 */

export const REP_HEADER_HEIGHT = 56;

const bar: CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  height: REP_HEADER_HEIGHT,
  minHeight: REP_HEADER_HEIGHT,
  width: '100%',
  backgroundColor: '#2961fd',
  color: '#fff',
  flexShrink: 0,
  caretColor: 'transparent',
};

const iconContainer: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: 48,
  minWidth: 48,
};

const truncate: CSSProperties = {
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

/** The hamburger that opens the side menu (every legacy page shows it, desktop included). */
export const HeaderMenuButton = () => {
  const dispatch = useAppDispatch();
  return (
    <IconButton aria-label='Open navigation' onDark onClick={() => dispatch(SET_NAV_OPEN(true))}>
      <Menu className='rep:text-white' />
    </IconButton>
  );
};

export const HeaderComponent = ({
  icon,
  title,
  suffix,
}: {
  icon?: ReactNode;
  title: ReactNode;
  suffix?: ReactNode;
}) => (
  <div style={bar} className='palmetto-print-hide'>
    {icon ? <div style={iconContainer}>{icon}</div> : null}
    <div
      style={{
        ...truncate,
        flex: 1,
        paddingLeft: icon ? 0 : 12,
        color: 'rgba(255, 255, 255, 0.87)',
        fontSize: 20,
      }}>
      {title}
    </div>
    <div style={iconContainer}>{suffix}</div>
  </div>
);

export const DualTitleHeader = ({
  icon,
  titleBig,
  titleSmall,
  suffix,
}: {
  icon?: ReactNode;
  titleBig: ReactNode;
  titleSmall?: ReactNode;
  suffix?: ReactNode;
}) => (
  <div style={bar} className='palmetto-print-hide'>
    {icon ? <div style={iconContainer}>{icon}</div> : null}
    <div
      style={{
        ...truncate,
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        paddingLeft: icon ? 0 : 12,
      }}>
      <div style={{ ...truncate, fontSize: 16, lineHeight: 1.2, textAlign: 'left' }}>
        {titleBig}
      </div>
      <div
        style={{
          ...truncate,
          fontSize: 12,
          lineHeight: 1.2,
          textAlign: 'left',
          color: 'rgba(255,255,255,0.75)',
        }}>
        {titleSmall}
      </div>
    </div>
    <div style={iconContainer}>{suffix}</div>
  </div>
);
